import React from "react";
import { Link } from "react-router-dom";
import DefaultData from "../../CompanyData/DefaultData"; // Adjust path if needed

const ViasTabs = (props) => {
  const baseTabStyle = {
    border: "none",
    fontWeight: "500",
    padding: "0.75rem 1.5rem",
    borderRadius: "0.375rem 0.375rem 0 0",
  };
  const inactiveTabStyle = {
    ...baseTabStyle,
    backgroundColor: "transparent",
    color: DefaultData.THEMECOLOR3,
    opacity: 2,
  };
  const activeTabStyle = {
    ...baseTabStyle,
    backgroundColor: DefaultData.THEMECOLOR2,
    color: DefaultData.THEMECOLOR3,
  };
  const getStyle = (pageName) =>
    props.pageName === pageName ? activeTabStyle : inactiveTabStyle;

  return (
    <div
      style={{
        backgroundColor: DefaultData.THEMECOLOR5,
        padding: "0 1rem",
        borderBottom: `1px solid ${DefaultData.THEMECOLOR2}`,
      }}
    >
      <ul className="nav nav-tabs" style={{ borderBottom: "none" }}>
        <li className="nav-item" role="presentation">
          <Link to={"/visas"} className="nav-link" style={getStyle("VISAS")}>
            SEARCH
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to={"/requests"}
            className="nav-link"
            style={getStyle("REQUESTS")}
          >
            REQUESTS
          </Link>
        </li>
        {/* <li className="nav-item" role="presentation">
          <Link
            to={"/visarequestreport"}
            className="nav-link"
            style={getStyle("VISA REQUEST REPORTS")}
          >
            ORDERS REPORT
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to={"/visasupplierreport"}
            className="nav-link"
            style={getStyle("VISA SUPPLIER REPORTS")}
          >
            SUPPLIER REPORT
          </Link>
        </li> */}
        <li className="nav-item" role="presentation">
          <Link
            to={"/visaappointments"}
            className="nav-link"
            style={getStyle("APPOINTMENT CALENDAR")}
          >
            VISA APPOINTMENT{" "}
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default ViasTabs;
